import React, { useState, useEffect } from 'react'
import { signOut } from 'firebase/auth'
import { auth, db } from '../firebase/config'
import { collection, addDoc, query, where, orderBy, getDocs } from 'firebase/firestore'
import MapView from './MapView'
import EventAlerts from './EventAlerts'
import PerformanceTracker from './PerformanceTracker'

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('map')
  const [userLocations, setUserLocations] = useState([])
  const [loading, setLoading] = useState(false)

  const handleSignOut = async () => {
    try {
      await signOut(auth)
    } catch (error) {
      console.error('Error signing out:', error)
    }
  }

  const addLocation = async (locationData) => {
    setLoading(true)
    try {
      await addDoc(collection(db, 'locations'), {
        ...locationData,
        userId: auth.currentUser.uid,
        createdAt: new Date(),
      })
      // Refresh locations
      fetchUserLocations()
    } catch (error) {
      console.error('Error adding location:', error)
    } finally {
      setLoading(false)
    }
  }

  const fetchUserLocations = async () => {
    try {
      const q = query(
        collection(db, 'locations'),
        where('userId', '==', auth.currentUser.uid),
        orderBy('createdAt', 'desc')
      )
      const querySnapshot = await getDocs(q)
      const locations = []
      querySnapshot.forEach((doc) => {
        locations.push({ id: doc.id, ...doc.data() })
      })
      setUserLocations(locations)
    } catch (error) {
      console.error('Error fetching locations:', error)
    }
  }

  useEffect(() => {
    fetchUserLocations()
  }, [])

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-left">
          <h1>🚚 TruckSpot</h1>
          <span className="user-email">{auth.currentUser?.email}</span>
        </div>
        <button onClick={handleSignOut} className="sign-out-button">
          Sign Out
        </button>
      </header>

      <nav className="dashboard-nav">
        <button 
          className={activeTab === 'map' ? 'nav-button active' : 'nav-button'}
          onClick={() => setActiveTab('map')}
        >
          📍 Map & Locations
        </button>
        <button 
          className={activeTab === 'events' ? 'nav-button active' : 'nav-button'}
          onClick={() => setActiveTab('events')}
        >
          🎉 Event Alerts
        </button>
        <button 
          className={activeTab === 'performance' ? 'nav-button active' : 'nav-button'}
          onClick={() => setActiveTab('performance')}
        >
          📊 Performance
        </button>
      </nav>

      <main className="dashboard-content">
        {activeTab === 'map' && (
          <MapView 
            locations={userLocations}
            onAddLocation={addLocation}
            loading={loading}
          />
        )}
        {activeTab === 'events' && <EventAlerts />}
        {activeTab === 'performance' && (
          <PerformanceTracker locations={userLocations} />
        )}
      </main>
    </div>
  )
}

export default Dashboard